import { jsonStringify } from '@ringcentral/rwc-utils/src/lang/json';
import { AbstractTransport } from './abstract-transport';
import '../types';
import { serializeMsgPartsMemoized } from '../utils';

export class DesktopSdkTransport extends AbstractTransport {
    constructor(opts, desktopLog) {
        super(opts);
        this.desktopLog = desktopLog;
    }

    /** @param {LoggerFormattedMessage} message - message formatted by logger */
    log(message) {
        const msg = { ...message };
        msg.parts = serializeMsgPartsMemoized(msg.parts);
        this.desktopLog(jsonStringify(msg));
    }
}
